// TAKE COMPONENTS FROM PARTNERS REPO
<template>
  <div class="pagination" v-if="lastPage > 1">
    <div
      v-for="item in displayedPages"
      :key="item"
      class="pagination__button"
      @click="item !== '...' && goToPage(item)"
      :class="{ active: item === currentPage, disabled: item === '...' }"
    >
      <span class="pagination__button__text">{{ item }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  lastPage: {
    type: Number,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
});

const emits = defineEmits(["onChangePage"]);

const displayedPages = computed(() => {
  const pages = [];
  const totalPages = props.lastPage;
  const currentPage = props.currentPage;

  if (totalPages <= 7) {
    // Show all pages if total pages are 7 or less
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    // Logic for more than 7 pages
    const startWindow = Math.max(1, currentPage - 2);
    const endWindow = Math.min(totalPages, currentPage + 2);

    // Add first page and '...' if needed
    if (startWindow > 1) {
      pages.push(1);
      if (startWindow > 2) {
        pages.push('...');
      }
    }

    // Add pages within the window
    for (let i = startWindow; i <= endWindow; i++) {
      pages.push(i);
    }

    // Add '...' and last page if needed
    if (endWindow < totalPages) {
      if (endWindow < totalPages - 1) {
        pages.push('...');
      }
      pages.push(totalPages);
    }
  }

  return pages;
});

function goToPage(pageNumber) {
  emits("onChangePage", pageNumber);
}
</script>
<style scoped lang="scss">
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #7a70df;
    border-radius: 7px;
    transition: 0.3s;
    padding: 5px 10px;
    &:hover {
      background-color: #7a70df;
      color: white;
    }
    &__text {
      font-family: Gilroy;
      font-size: 15px;
      font-weight: 500;
    }
  }
}
.active {
  background-color: #7a70df;
  color: white;
}
</style>
